import { GlobalState } from '../../global-state/global-state';
import { ToggleQuickshopSidebar } from '../product-quickshop/toggle-quickshop-component';
import {
  setProductAbsorbencyDropRating,
  setProductCardBadge,
  setGTMcompareProductsEvent,
} from '../../utils/helpers';

const ProductCardComponent = {
  name: 'product-card',
  template: '#vue-product-card-component',
  props: ['productData', 'sampleKit', 'sampleKitWeight', 'sampleVariantId', 'sampleHandle', 'sampleTags'],
  components: {
    'toggle-quickshop': ToggleQuickshopSidebar,
  },
  data: function () {
    return {
      showAddToCompareFeature: true,
      productCardsv1: {},
      productCards: [],
      sharedState: GlobalState.state,
      isSelectedv1: {},
      ctaButtonIsEnabled: true,
    };
  },
  methods: {
    renderDropletRating: function (tags) {
      return setProductAbsorbencyDropRating(tags);
    },
    renderProductBadge: function (data) {
      return setProductCardBadge(data);
    },
    ctaButtonClick: function (event) {
      // Need method to prevent VUE JS error.
    },
    addToCompareList: function (data) {
      if (this.compareList.length < 3) {
        const checkProductIsInArray = (product) =>
          product === data.productHandle;
        const compareListArray = GlobalState.getCompareList(this);
        let alreadyInArray = compareListArray.some(checkProductIsInArray);

        if (!alreadyInArray) {
          this.compareList.push({
            compareListPosition: this.compareList.length,
            id: data.id,
            handle: data.handle,
            title: data.title,
            imageSource: data.image,
          });

          // Set Global State
          GlobalState.setCompareList(this, this.compareList);

          // Set Google GTM Data Layer Veriable
          const gtmCompareProducts = GlobalState.getCompareList(this).map(
            (product) => product.title
          );
          setGTMcompareProductsEvent(
            gtmCompareProducts,
            'Homepage Recommendation'
          );
        }
      }
    },
    removeFromCompareList: function (productID) {
      const deselectedProduct = this.compareList.filter(
        (item) => Number(item.id) === Number(productID)
      )[0];
      const indexInCompareList = deselectedProduct['compareListPosition'];

      // Remove from Array
      this.compareList.splice(indexInCompareList, 1);

      // Update the Compare List Index for Product Removal
      this.compareList.map((item, index) => (item.compareListPosition = index));

      // Update Local Storage
      GlobalState.setCompareList(this, this.compareList);
    },
  },
  filters: {
    money: function (value, sign = '$') {
      if (!value) return 0;
      return sign + value;
    },
    shopifyProductID: function (base64Id) {
      const decoded = atob(base64Id);
      const shopifyId = decoded.split('/').pop();
      return parseInt(shopifyId);
    },
  },
  computed: {
    compareList: function () {
      return this.sharedState.compareProductList;
    },
    isSelected: function () {
      return this.sharedState.selectedCompareProductIds;
    },
  },
};

export default ProductCardComponent;
